import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import { FormPanel } from "@/components/auth/form-panel";
import { FormPanelHeader } from "@/components/auth/form-panel-header";
import { FormHeading } from "@/components/auth/form-heading";
import InviteSignupForm from "@/components/auth/InviteSignupForm";

export const Route = createFileRoute("/_auth/invite")({
  component: InvitePage,
});

function InvitePage() {
  const t = useTranslations();

  return (
    <AuthShell>
      <BrandPanel page="signup" />
      <FormPanel>
        <FormPanelHeader
          linkOpposite={{
            href: "/signin",
            prompt: t("auth.invite.have_account"),
            cta: t("auth.invite.link_signin"),
          }}
        />
        <FormHeading
          title={t("auth.invite.title")}
          description={t("auth.invite.desc")}
        />
        <InviteSignupForm />
      </FormPanel>
    </AuthShell>
  );
}
